<template lang="">
	<AccountLayout :loading="0" :isError=true>
		<v-container id="login">
			<v-row id="login-box" class="d-flex justify-center">
				<v-col
					class="pl-0"
					cols="12"
					sm="auto"
					md="auto"
					style="display:flex; z-index: 1; justify-center"
					>
						<div id="half-border">
							<v-img
							:src="require('@/assets/Group 92915.svg')"
							contain
							width="341"
							height="372"
							style="
								position: absolute;
								z-index: 1;
								margin-top: 4rem;
								margin-left: -10rem;
							"
							/>
						</div>
					<v-card
						max-width="540"
						height="544px"
						style="border-radius: 0px 30px 30px 0px"
						elevation="0"
					>
						<v-card-text>
						<v-form ref="form" v-model="valid" lazy-validation>
							<v-row class="mx-6">
								<v-col cols="12" sm="12" md="12" class="text-center">
									<div
									class="mt-7 prompt-title-500"
									style="color: #255d98; font-weight: 400"
									>
									{{$t('message.loginPage.linkExpired')}}
									</div>
								</v-col>
								<v-col sm="12" md="12" class="form-subtitle-400">
									{{$t('message.loginPage.expiredMessage')}}
								</v-col>
								<v-col cols="12" sm="12" md="12">
									<div class="pa-1 form-label">{{$t('message.loginPage.email')}} <strong>*</strong></div>
									<v-text-field
										dense
										outlined
										hide-details="auto"
										v-bind:placeholder="$t('message.loginPage.fillEmail')"
										v-model="email"
										:rules="emailRules"
										type="email"
										required
									></v-text-field>
								</v-col>
								<v-col
									cols="12"
									sm="12"
									md="12"
									class="d-flex justify-center"
								>
									<v-btn
										class="prompt-24"
										:disabled="!checkFill"
											:color="checkFill ? '#FF9800' : '#AFADB1'"
										@click="validate"
										rounded
										height="40"
										width="300"
										style="
											font-weight: 400;
											font-size: 18px;
											line-height: 24px;
											letter-spacing: 0.05rem;
											color: #ffffff;
										"
										>
										{{$t('message.loginPage.confirm')}}
									</v-btn>
								</v-col>
								<v-col
									cols="12"
									sm="12"
									md="12"
									class="d-flex justify-center"
								>
									<a
										class="prompt-underline text-decoration-underline"
										href="/login"
										style="color: #ff9800"
										>{{$t('message.loginPage.back')}}</a
									>
								</v-col>
							</v-row>
						</v-form>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		<div id="orange-tab"></div>
		</v-container>
	</AccountLayout>
</template>


<script>
import AccountLayout from "@/components/common/AccountLayout";
import router from "@/router";
import * as services from "../../services";

export default {
    name: "PasswordExpired",
    components: { AccountLayout },
    data: () => ({
        valid: true,
        email: "",
        path: "",
        foundEmail: true,
        checkSubmit: false,
        emailRules: [
            (v) => !!v || "E-mail is required",
            (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
        ],
        link: "",
        expireDate: "",
		isError:true
    }),
    computed: {
        checkFill() {
            const validate = this.$refs.form;
            const checkNull = this.email != "";
            return validate?.value && checkNull;
        },
    },
    methods: {
        async validate() {
            const valid = this.$refs.form.validate();
            if (valid) {
                this.checkSubmit = true;
                try {
                    const {
                        data: { data },
                    } = await services.getChangePasswordLink({
                        email: this.email,
                        path: this.path,
                    });

                    this.link = data.token;

                    if (
                        this.link != "" &&
                        this.link != null &&
                        this.link !== undefined
                    ) {
                        this.foundEmail = true;
                    } else {
                        this.foundEmail = false;
                    }
                } catch (err) {
                    console.log(err);
                }
            }
        },
        changePassword() {
            router.push({
                path: `/account/forget-password/${this.link}`,
            });
        },
    },
    mounted() {
        this.path = window.location.hostname;
        if (this.path == "localhost") {
            this.path = `${window.location.hostname}:${window.location.port}`;
        }
        this.path = this.path + "/account/forget-password/";
    },
};


</script>
<style lang=""></style>
